import React from 'react';

import { forwardRef, Input as ChakraInput } from '@chakra-ui/react';

import { useFormControlGroup } from '../../hooks/use-form-control-group';
import { InputProps } from './types';

const Input = forwardRef<InputProps, 'input'>(
  ({ ignoreContext, ...restOfInputProps }: InputProps, ref) => {
    const { contextData } = useFormControlGroup();
    const inputProps = {
      ...restOfInputProps,
      ...(ignoreContext
        ? {}
        : (contextData?.components?.Input as InputProps) || {}),
    };
    return <ChakraInput ref={ref} {...inputProps} />;
  }
);
export { Input };
